var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3CCFE6"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0FA1B8"
    },
    d: "M256,76.8c-98.97,0-179.2,80.23-179.2,179.2S157.03,435.2,256,435.2S435.2,354.97,435.2,256 S354.97,76.8,256,76.8z M256,409.6c-84.831,0-153.6-68.769-153.6-153.6S171.169,102.4,256,102.4S409.6,171.169,409.6,256 S340.831,409.6,256,409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2EC2D9"
    },
    d: "M281.6,486.4c-141.385,0-256-114.615-256-256c0-64.177,23.618-122.836,62.634-167.766 C34.181,109.57,0,178.793,0,256c0,141.385,114.615,256,256,256c77.208,0,146.43-34.181,193.366-88.234 C404.436,462.782,345.777,486.4,281.6,486.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M256,68.267C152.318,68.267,68.267,152.318,68.267,256S152.318,443.733,256,443.733 S443.733,359.682,443.733,256S359.682,68.267,256,68.267z M256,418.133c-89.543,0-162.133-72.59-162.133-162.133 S166.457,93.867,256,93.867S418.133,166.457,418.133,256S345.543,418.133,256,418.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M409.594,179.481c0.001-0.092,0.006-0.19,0.006-0.281c0-0.139-0.01-0.274-0.011-0.412 c-0.001-0.023,0-0.048-0.002-0.071c-0.26-23.303-19.29-42.183-42.654-42.183c-23.526,0-42.667,19.14-42.667,42.667 c0,18.604,25.911,77.478,33.712,94.777l-18.219,50.754l-55.271-136.997h5.645c4.713,0,8.533-3.821,8.533-8.533 c0-4.713-3.821-8.533-8.533-8.533h-18.289h-55.21H204.8c-4.713,0-8.533,3.821-8.533,8.533c0,4.713,3.821,8.533,8.533,8.533h6.076 l32.732,81.131l-20.698,55.557l-55.147-136.688h2.903c4.713,0,8.533-3.821,8.533-8.533c0-4.713-3.821-8.533-8.533-8.533h-15.548 h-55.21h-6.043c-4.713,0-8.533,3.821-8.533,8.533c0,4.713,3.821,8.533,8.533,8.533h0.284l93.484,231.716 c-0.803,4.035,1.404,8.17,5.382,9.652c0.982,0.366,1.988,0.539,2.978,0.539c3.461,0,6.718-2.122,7.998-5.556l49.084-131.75 l52.028,128.959c-1.499,4.399,0.799,9.202,5.189,10.779c0.954,0.341,1.926,0.503,2.883,0.503c3.499,0,6.781-2.17,8.031-5.652 l55.788-155.409c8.817-19.698,32.258-73.718,32.596-91.915C409.593,179.559,409.593,179.52,409.594,179.481z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/Wordpress.21dffc1ec19f8bc702058b3d7249e642.svg";
export { ForwardRef as ReactComponent };